import { useEffect } from "react";
import { useNavigate } from "react-router";
import { FolderChatStatus, UserRole } from "~/api/model";
import { useGetProject } from "~/api/projects/projects";
import { useGetCurrentUser } from "~/api/users/users";
import { NotFound } from "~/components/NotFound";
import { PageLayout } from "~/components/PageLayout";
import { DocumentsList } from "~/features/case/components/list/DocumentsList";
import { CasePageTour } from "~/features/onboarding";
import { ROUTES, useProjectParams } from "~/helpers";
import { useTrackPageVisit } from "~/hooks/useTrackPageVisit";

export const CasePage = () => {
  useTrackPageVisit("app/case/visit");
  const { organizationId, caseId } = useProjectParams();
  const { data: project, isError: isProjectError } = useGetProject(
    organizationId,
    caseId
  );
  const navigate = useNavigate();
  const { data: userInfo } = useGetCurrentUser();

  const isTourReady = project?.chatStatus === FolderChatStatus.COMPLETE;

  useEffect(() => {
    if (userInfo?.role === UserRole.GUEST) {
      navigate(ROUTES.ACCESS_DENIED);
    }
  }, [userInfo, navigate]);

  if (isProjectError) {
    return <NotFound backRoute={ROUTES.CASES({ organizationId })} />;
  }

  return (
    <PageLayout>
      <CasePageTour isReady={isTourReady} />
      <DocumentsList />
    </PageLayout>
  );
};
